import {BaseAnalyticsEvent} from "../../../../infrastructure/models/analytics/base-analytics-event";
import {ANALYTICS} from "../../../../third-party-services/analytics/analytics-consts";

export class CompetitorPlayerStatsModuleStatsButtonClickEvent extends BaseAnalyticsEvent {
  gameId: Number;
  athleteId: String;
  sportTypeId: String;
  status: Number;
  source: String;
  clickType: String;

  constructor(params) {
    super('', 'click', 'live-stats_button');

    this.gameId = params.gameId;
    this.athleteId = params.athleteId;
    this.sportTypeId = params.sportTypeId;
    this.status = params.status;
    this.source = params.source;
    this.clickType = params.clickType;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.athleteId = this.athleteId;
    properties.sportTypeId = this.sportTypeId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.source = this.source;
    properties.clickType = this.clickType;

    return properties;
  }
}